__turbopack_context__.v({
  "arrival": "SiteFooter-module__7nVEHG__arrival",
  "compass": "SiteFooter-module__7nVEHG__compass",
  "footer": "SiteFooter-module__7nVEHG__footer",
  "footerArrival": "SiteFooter-module__7nVEHG__footerArrival",
  "links": "SiteFooter-module__7nVEHG__links",
  "subtitle": "SiteFooter-module__7nVEHG__subtitle",
  "title": "SiteFooter-module__7nVEHG__title",
});
